import { execOnLoad } from '@general/helpers';
import './shop-by-look.scss';
import 'swiper/scss';
import Swiper from 'swiper';
import breakpoints from 'breakpoints';
import { freeMode } from 'swiper/modules';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initShopByLook = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const slider = sectionContainer.querySelector('.shop-by-look__products');
  if (!slider) return;

  const options = {
    slidesPerView: 1.5,
    spaceBetween: 4,
    freeMode: true,
  };

  var swiperGallery;
  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleSwiper = () => {
    if (lgUp.matches) {
      if (swiperGallery && swiperGallery.destroy)
        swiperGallery.destroy(true, true);
    } else {
      swiperGallery = new Swiper(slider, options);
    }
  };
  handleSwiper();
  lgUp.addEventListener('change', handleSwiper);
};

execOnLoad(window.dAgency.initShopByLook, '.shop-by-look__section');
